import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Palette } from "lucide-react";
import { useTranslation } from "react-i18next";

export const SubNavbar = () => {
  const { t } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Visa alltid SubNavbar om vi är nära toppen
      if (currentScrollY < 100) {
        setIsVisible(true);
      } 
      // Dölj när man scrollar nedåt
      else if (currentScrollY > lastScrollY && currentScrollY > 150) {
        setIsVisible(false);
      } 
      // Visa när man scrollar uppåt
      else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div 
      className={`hidden md:block sticky top-[64px] z-40 bg-[hsl(var(--glass-bg))] backdrop-blur-xl border-b border-[hsl(var(--glass-border-strong))] shadow-[0_4px_16px_hsl(var(--glass-shadow)),inset_0_-1px_0_hsl(var(--glass-highlight))] transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="container">
        <div className="flex items-center justify-center h-12">
          {/* Navigation Links */}
          <div className="flex items-center gap-3 md:gap-6">
            <Link to="/explore" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <Palette className="h-4 w-4" />
              <span>{t('nav.allArtworks')}</span>
            </Link>
            <Link to="/explore?type=original" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <span>{t('nav.originals')}</span>
            </Link>
            <Link to="/explore?type=print" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <span>{t('nav.prints')}</span>
            </Link>
            <Link to="/artists" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <span>{t('nav.artists')}</span>
            </Link>
            <Link to="/explore?auction=true" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <span>{t('nav.auctions')}</span>
            </Link>
            <Link to="/supplies" className="flex items-center gap-1.5 text-xs md:text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
              <span>{t('nav.supplies')}</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
